import {Injectable} from '@angular/core';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../shared';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { ShoppingCardValidationModel} from '../../../../../models';

@Injectable({providedIn: 'root'})

export class EcomShoppingCartValidationService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'cp-commerce/update-payment-details/shopping-card-validation';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'cp-commerce/update-payment-details/shopping-card-validation';
    this.httpClient = http;
  }
  ecomShoppingCartValidation(requestData: ShoppingCardValidationModel, visa: ApiVisa): Observable<any> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<any>(this.apiUrl, requestData, {...this.getHttpHeader(visa), withCredentials: true});
  }
}
